import { render } from "./HomeAdditionLGFUpgrade.vue?vue&type=template&id=8f63105e"
import script from "./HomeAdditionLGFUpgrade.vue?vue&type=script&lang=js"
export * from "./HomeAdditionLGFUpgrade.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__